module.exports = __webpack_public_path__ + "static/img/code2.1a47be5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/code2.jpg
// module id = Zy9R
// module chunks = 36